export const EVENT_UI_POSITIONS = {
  CC_HEATMAPS: 'Continuous Capture Heatmaps',
  REPORT: 'Heatmap Report',
  TC_PENDING_STATE: 'Pending Installation Empty State',
  URL_SEARCH: 'Heatmap URL Search',
  SIDE_BAR: 'Heatmap Sidebar',
  HEATMAP_GENERATION_ERROR: 'Heatmap Generation Error',
  HEADER: 'Heatmap Header',
  SMART_PANEL: 'Smart Panel',
  MAGIC_RULER: 'Magic Ruler',
};
